import { render, staticRenderFns } from "./SectionFaq.vue?vue&type=template&id=3665e3d8&scoped=true"
import script from "./SectionFaq.vue?vue&type=script&lang=ts"
export * from "./SectionFaq.vue?vue&type=script&lang=ts"
import style0 from "./SectionFaq.vue?vue&type=style&index=0&id=3665e3d8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3665e3d8",
  null
  
)

export default component.exports